import React from 'react';
import { useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Paper,
  Breadcrumbs,
  Link as MuiLink,
} from '@mui/material';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { useGetWebhookDetailsQuery } from '../services/webhooks.endpoints';

const WebhookDetail = () => {
  const { id } = useParams<{ id: string }>();
  const {
    data: webhook,
    isLoading,
    isError,
    error,
  } = useGetWebhookDetailsQuery(id || '');

  if (isLoading) return <div>Loading...</div>;
  if (isError) {
    const message =
      'data' in error && error.data
        ? JSON.stringify(error.data)
        : 'An error occurred';
    return <div>Error: {message}</div>;
  }

  return (
    <Container maxWidth="md">
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
        <MuiLink underline="hover" color="inherit" href="/">
          Home
        </MuiLink>
        <MuiLink underline="hover" color="inherit" href="/#/webhooks">
          Webhooks
        </MuiLink>
        <Typography color="text.primary">Webhook Details</Typography>
      </Breadcrumbs>

      <Typography variant="h4" sx={{ mb: 2 }}>
        Webhook Details
      </Typography>
      <Box sx={{ my: 2 }}>
        {webhook && (
          <Paper style={{ padding: '20px', backgroundColor: '#f5f5f5' }}>
            <Typography variant="h6">ID: {webhook._id}</Typography>
            <Typography variant="h6">
              User ID: {webhook.userId || 'N/A'}
            </Typography>
            <Typography variant="h6">Type: {webhook.type}</Typography>
            <Typography variant="h6">
              Time: {new Date(webhook.createdAt).toLocaleString()}
            </Typography>
            <Typography variant="h6">Subject:</Typography>
            <SyntaxHighlighter language="json" style={docco}>
              {JSON.stringify(webhook.data, null, 2)}
            </SyntaxHighlighter>
          </Paper>
        )}
      </Box>
    </Container>
  );
};

export default WebhookDetail;
